module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/223-turks-and-caicos-05a62dd53bfc2d24560f4fb764b51bae.svg";